"use strict";
/**
 * @fileoverview gRPC-Web generated client stub for loopup.ctgateway.v2
 * @enhanceable
 * @public
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvisioningAPIClient = void 0;
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck
var grpcWeb = require("grpc-web");
var v2_provisioning_api_pb = require("../v2/provisioning_api_pb");
var ProvisioningAPIClient = /** @class */ (function () {
    function ProvisioningAPIClient(hostname, credentials, options) {
        this.methodInfoProvisionServiceUserWithSpecificDdi = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.ProvisioningAPI/ProvisionServiceUserWithSpecificDdi', grpcWeb.MethodType.SERVER_STREAMING, v2_provisioning_api_pb.ProvisionServiceUserWithSpecificDdiRequest, v2_provisioning_api_pb.ProvisionServiceUserWithSpecificDdiResponse, function (request) {
            return request.serializeBinary();
        }, v2_provisioning_api_pb.ProvisionServiceUserWithSpecificDdiResponse.deserializeBinary);
        this.methodInfoProvisionServiceUserWithRandomDdi = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.ProvisioningAPI/ProvisionServiceUserWithRandomDdi', grpcWeb.MethodType.SERVER_STREAMING, v2_provisioning_api_pb.ProvisionServiceUserWithRandomDdiRequest, v2_provisioning_api_pb.ProvisionServiceUserWithRandomDdiResponse, function (request) {
            return request.serializeBinary();
        }, v2_provisioning_api_pb.ProvisionServiceUserWithRandomDdiResponse.deserializeBinary);
        this.methodInfoDeprovisionServiceUser = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.ProvisioningAPI/DeprovisionServiceUser', grpcWeb.MethodType.SERVER_STREAMING, v2_provisioning_api_pb.DeprovisionServiceUserRequest, v2_provisioning_api_pb.DeprovisionServiceUserResponse, function (request) {
            return request.serializeBinary();
        }, v2_provisioning_api_pb.DeprovisionServiceUserResponse.deserializeBinary);
        this.methodInfoGetProvisioningUpdates = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.ProvisioningAPI/GetProvisioningUpdates', grpcWeb.MethodType.SERVER_STREAMING, v2_provisioning_api_pb.GetProvisioningUpdatesRequest, v2_provisioning_api_pb.GetProvisioningUpdatesResponse, function (request) {
            return request.serializeBinary();
        }, v2_provisioning_api_pb.GetProvisioningUpdatesResponse.deserializeBinary);
        this.methodInfoGetDeprovisioningUpdates = new grpcWeb.MethodDescriptor('/loopup.ctgateway.v2.ProvisioningAPI/GetDeprovisioningUpdates', grpcWeb.MethodType.SERVER_STREAMING, v2_provisioning_api_pb.GetDeprovisioningUpdatesRequest, v2_provisioning_api_pb.GetDeprovisioningUpdatesResponse, function (request) {
            return request.serializeBinary();
        }, v2_provisioning_api_pb.GetDeprovisioningUpdatesResponse.deserializeBinary);
        if (!options)
            options = {};
        if (!credentials)
            credentials = {};
        options['format'] = 'text';
        this.client_ = new grpcWeb.GrpcWebClientBase(options);
        this.hostname_ = hostname;
        this.credentials_ = credentials;
        this.options_ = options;
    }
    ProvisioningAPIClient.prototype.provisionServiceUserWithSpecificDdi = function (request, metadata) {
        return this.client_.serverStreaming(this.hostname_ +
            '/loopup.ctgateway.v2.ProvisioningAPI/ProvisionServiceUserWithSpecificDdi', request, metadata || {}, this.methodInfoProvisionServiceUserWithSpecificDdi);
    };
    ProvisioningAPIClient.prototype.provisionServiceUserWithRandomDdi = function (request, metadata) {
        return this.client_.serverStreaming(this.hostname_ +
            '/loopup.ctgateway.v2.ProvisioningAPI/ProvisionServiceUserWithRandomDdi', request, metadata || {}, this.methodInfoProvisionServiceUserWithRandomDdi);
    };
    ProvisioningAPIClient.prototype.deprovisionServiceUser = function (request, metadata) {
        return this.client_.serverStreaming(this.hostname_ +
            '/loopup.ctgateway.v2.ProvisioningAPI/DeprovisionServiceUser', request, metadata || {}, this.methodInfoDeprovisionServiceUser);
    };
    ProvisioningAPIClient.prototype.getProvisioningUpdates = function (request, metadata) {
        return this.client_.serverStreaming(this.hostname_ +
            '/loopup.ctgateway.v2.ProvisioningAPI/GetProvisioningUpdates', request, metadata || {}, this.methodInfoGetProvisioningUpdates);
    };
    ProvisioningAPIClient.prototype.getDeprovisioningUpdates = function (request, metadata) {
        return this.client_.serverStreaming(this.hostname_ +
            '/loopup.ctgateway.v2.ProvisioningAPI/GetDeprovisioningUpdates', request, metadata || {}, this.methodInfoGetDeprovisioningUpdates);
    };
    return ProvisioningAPIClient;
}());
exports.ProvisioningAPIClient = ProvisioningAPIClient;
